// extracted by mini-css-extract-plugin
export default {"cardContent":"ReagentContent_cardContent__hrqPP","buttons":"ReagentContent_buttons__B4q+n","addPredilutionButton":"ReagentContent_addPredilutionButton__m31RM"};